var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showMessageBox
    ? _c("div", { staticClass: "message-box-bg flex-center" }, [
        _c("div", { staticClass: "message-box" }, [
          _c("div", { staticClass: "message-box-main" }, [
            _c("div", { staticClass: "message-box-top" }, [
              _c("i", {
                staticClass: "icon icon-close",
                on: { click: _vm.onShowMessageBox },
              }),
            ]),
            _c("div", { staticClass: "message-box-content" }, [
              _c("i", { staticClass: "icon icon-pair-suspended" }),
              _c("h4", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "home.walletConnect.acknowledgementTermsMessageBox.readThis"
                      )
                    ) +
                    " "
                ),
              ]),
              _c("p", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "home.walletConnect.acknowledgementTermsMessageBox.byTradingText"
                      )
                    ) +
                    " "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      rel: "noopener noreferrer",
                      href: "https://marginx.io/terms/",
                    },
                  },
                  [
                    _c("strong", { staticClass: "text-invite-address" }, [
                      _vm._v(
                        " <" +
                          _vm._s(
                            _vm.$t(
                              "home.walletConnect.acknowledgementTermsMessageBox.termsofUseText"
                            )
                          ) +
                          ">"
                      ),
                    ]),
                  ]
                ),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "home.walletConnect.acknowledgementTermsMessageBox.andText"
                      )
                    ) +
                    " "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      rel: "noopener noreferrer",
                      href: "https://marginx.io/privacy-policy/",
                    },
                  },
                  [
                    _c("strong", { staticClass: "text-invite-address" }, [
                      _vm._v(
                        " <" +
                          _vm._s(
                            _vm.$t(
                              "home.walletConnect.acknowledgementTermsMessageBox.privacyPolicyText"
                            )
                          ) +
                          ">"
                      ),
                    ]),
                    _vm._v("."),
                  ]
                ),
              ]),
              _c("p", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "home.walletConnect.acknowledgementTermsMessageBox.itAppearsText"
                      )
                    ) +
                    " "
                ),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "message-box-bott" },
            [
              _c("p", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "home.walletConnect.acknowledgementTermsMessageBox.text1"
                      )
                    ) +
                    " "
                ),
              ]),
              _c("p", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "home.walletConnect.acknowledgementTermsMessageBox.text2"
                      )
                    ) +
                    " "
                ),
              ]),
              _c("p", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "home.walletConnect.acknowledgementTermsMessageBox.text3"
                      )
                    ) +
                    " "
                ),
              ]),
              _c("p", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "home.walletConnect.acknowledgementTermsMessageBox.text4"
                      )
                    ) +
                    " "
                ),
              ]),
              _c("p", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "home.walletConnect.acknowledgementTermsMessageBox.text5"
                      )
                    ) +
                    " "
                ),
              ]),
              _c(
                "label",
                { staticClass: "i-agree flex-center", attrs: { for: "radio" } },
                [
                  _c("input", {
                    attrs: { type: "radio", id: "radio" },
                    domProps: { checked: _vm.isChecked },
                    on: { click: _vm.getRadioVal },
                  }),
                  _c("h6", { staticClass: "background-clip-text h6-min" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "home.walletConnect.acknowledgementTermsMessageBox.iAgree"
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]
              ),
              _c(
                "ButtonCommon",
                {
                  staticClass: "flex-center box-but",
                  attrs: {
                    type: "marginXBridge",
                    width: "320px",
                    disabled: !_vm.isChecked,
                  },
                  on: { click: _vm.toIAgree },
                },
                [
                  _c("strong", { staticClass: "text-max" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "home.walletConnect.acknowledgementTermsMessageBox.next"
                        )
                      )
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }